export default class OrderBookingNoteNotifications {
  constructor($scope, OrderBookingNoteService) {
    function load_data() {
      OrderBookingNoteService.get_notifications(window.order.id).success(function(data) {
        if (data.success)
          $scope.notifications = data.notifications;
      });
    }

    $scope.resend_notification = function(notification) {
      if (confirm('Are you sure you want to resend this notification?')) {
        notification.resending = true;
        OrderBookingNoteService.resend_notification(notification.id).success(function(data) {
          if (data.success) {
            notification.resending = false;
            load_data();
          }
        });
      }
    };

    $scope.init = function() {
      load_data();
    };

    $scope.init();
  }
}

OrderBookingNoteNotifications.$inject = ['$scope', 'OrderBookingNoteService'];



// WEBPACK FOOTER //
// ./front/js/admin/controllers/order-booking-note-notifications.ctrl.js